import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Login from "../Login/Login";
import Cookies from 'js-cookie';
import './App.css';
import Inventario from "../Inventario/Inventario";
import Carrito from "../Carrito/Carrito";
import Pedidos from "../Pedidos/Pedidos";
import ProductoNegado from "../productonegado/ProductoNegado";
import Dashboard from "../Administracion/Administracion";
import PedidosExpress from "../PedidosExpress/PedidosExpress";

const PrivateRoute = ({ children }) => {
  const token = Cookies.get('authToken');
  return token ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login.html" element={<Login />} />
        <Route path="/inventario.html" element={
          <PrivateRoute>
            <Inventario />
          </PrivateRoute>
        } />
        <Route path="/carrito.html" element={
          <PrivateRoute>
            <Carrito />
          </PrivateRoute>
        } />
        <Route path="/pedidos.html" element={
          <PrivateRoute>
            <Pedidos />
          </PrivateRoute>
        } />
        <Route path="/pedidosExpress.html" element={
          <PrivateRoute>
            <PedidosExpress />
          </PrivateRoute>
        } />
        <Route path="/productonegado.html" element={
          <PrivateRoute>
            <ProductoNegado />
          </PrivateRoute>
        } />
        <Route path="/administracionLago.html" element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;
